import dateFormat from "dateformat";

//EXCEL
import * as FileSaver from 'file-saver';
import XLSX from 'tempa-xlsx';
import { strToArrBuffer, excelSheetFromDataSet } from "../../../utilities/dataHelpers";

export const excelRPT212 = (dataReport) => {
    // setLoading(true)
    let newData = dataModifyToExcel(dataReport)
    let runNum = newData.length > 0 && newData[0].runNum ? newData[0].runNum : 6;
    
    let setBorder = {
        "left": {
            "style": "thin",
            "color": {
                "auto": 1
            }
        },
        "right": {
            "style": "thin",
            "color": {
                "auto": 1
            }
        },
        "top": {
            "style": "thin",
            "color": {
                "auto": 1
            }
        },
        "bottom": {
            "style": "thin",
            "color": {
                "auto": 1
            }
        }
    };
    let styleTextHeaders = {
        fill: {
            fgColor: { rgb: "c7c7c7" }
        },
        font: { bold: true },
        alignment: {
            horizontal: "center", vertical: "center", wrapText: true
        },
        border: setBorder,

    };
    let styleHeaders = {
        fill: {
            fgColor: { rgb: "c7c7c7" }
        },
        font: { bold: true },
        alignment: {
            horizontal: "center", vertical: "center", wrapText: true
        },
        border: setBorder,
    };
    let styleBorderB = {
        fill: {
            fgColor: { rgb: "ffffff" }
        },
        border: setBorder,
        alignment: {
            vertical: "center", wrapText: true
        },
    };

    let styleSummaryHeaders = {
        fill: {
            fgColor: { rgb: "ffd966" }
        },
        font: { bold: true },
        alignment: {
            horizontal: "center", vertical: "center", wrapText: true
        },
        border: setBorder,
    };

    let styleSummary = {
        fill: {
            fgColor: { rgb: "ffd966" }
        },
        font: { bold: true },
        alignment: {
            horizontal: "right", vertical: "center", wrapText: true
        },
        border: setBorder,
    };
    
    // const { readData } = this.props;
    // dataReport

    if (newData && newData.length > 0) {
        let dataRow = newData
        let dataExcel = []
        let headerText = [{
            "text": "สรุปค่างานเส้นทาง",
            "style": styleTextHeaders
        },
        {}
        ]

        //หัวรายงาน
        for (let i = 0; i < headerText.length; i++) {            
            dataExcel.push([{ value: headerText[i].text, style: headerText[i].style }])
        }

        // ADD Row
        for (let i = 0; i < dataRow.length; i++) {
            //dataExcel
            let dataRowTmp= []
            if(i === dataRow.length-1){
                
                dataRowTmp.push(
                    { value: dataRow[i].col1 ? dataRow[i].col1 : '', style: styleSummary },
                    { value: dataRow[i].col2 ? dataRow[i].col2 : '', style: styleSummaryHeaders },
                    { value: dataRow[i].col3 ? dataRow[i].col3 : '', style: styleSummary },
                    { value: dataRow[i].col4 ? dataRow[i].col4 : '', style: styleSummary },
                    { value: dataRow[i].col5 ? dataRow[i].col5 : '', style: styleSummary },
                    { value: dataRow[i].col6 ? dataRow[i].col6 : '', style: styleSummary },
                )
    
                if(runNum > 6){
                    for(let j = 7; j <= runNum ; j++){
                        dataRowTmp.push(
                            { value: dataRow[i][`col${j}`] ? dataRow[i][`col${j}`] : '', style: styleSummary }
                        )
                    }
                }

            }else{
                dataRowTmp.push(
                    { value: dataRow[i].col1 ? dataRow[i].col1 : '', style: i < 2?styleHeaders:styleBorderB },
                    { value: dataRow[i].col2 ? dataRow[i].col2 : '', style: i < 2?styleHeaders:styleBorderB },
                    { value: dataRow[i].col3 ? dataRow[i].col3 : '', style: i < 2?styleHeaders:styleBorderB },
                    { value: dataRow[i].col4 ? dataRow[i].col4 : '', style: i < 2?styleHeaders:styleBorderB },
                    { value: dataRow[i].col5 ? dataRow[i].col5 : '', style: i < 2?styleHeaders:styleBorderB },
                    { value: dataRow[i].col6 ? dataRow[i].col6 : '', style: i < 2?styleHeaders:styleBorderB },
                )
    
                if(runNum > 6){
                    for(let j = 7; j <= runNum ; j++){
                        dataRowTmp.push(
                            { value: dataRow[i][`col${j}`] ? dataRow[i][`col${j}`] : '', style: i < 2?styleHeaders:styleBorderB }
                        )
                    }
                }

            }

            dataExcel.push(dataRowTmp)
        }
        //"xlsx"  "csv"
        exportFile(dataExcel,runNum)
        // this.handleCloseExport()
    } else {
        alert("เกิดข้อผิดพลาด : ไม่พบข้อมูลส่งออก")
        // showMessages(toast,'warn', `เกิดข้อผิดพลาด`, 'ไม่พบข้อมูลส่งออก');
    }
}

const exportFile = (dataExcel,runNum) => {
    
    let filename = "RPT212_" + dateFormat(new Date(), 'yyyymmdd')

    let mergesData = [
        { s: { r: 0, c: 0 }, e: { r: 1, c: runNum-1 }  },
        { s: { r: 2, c: 0 }, e: { r: 3, c: 0 }  },
        { s: { r: 2, c: 1 }, e: { r: 3, c: 1 }  },
        { s: { r: 2, c: 2 }, e: { r: 3, c: 2 }  },
        { s: { r: 2, c: 3 }, e: { r: 3, c: 3 }  },
        { s: { r: 2, c: 4 }, e: { r: 2, c: 5 }  }
    ]

    let i = 1
    if(runNum > 6){
        for(let j = 7; j <= runNum ; j++){
            mergesData.push(
                { s: { r: 2, c: 4+i }, e: { r: 2, c: 5+i }  }
            )
            i++;
        }
    }
    const wb = {
        SheetNames: [filename],
        Sheets: {
            [filename]: excelSheetFromDataSet([{
                columns: null,
                data: dataExcel,
                merges: mergesData,
                page: "RPT212"
            }])
        }
    };
    const wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'binary' });
    let data = (new Blob([strToArrBuffer(wbout)], { type: "application/octet-stream" }));
    FileSaver.saveAs(data, filename + "." + 'xlsx');
    // setLoading(false)
}

const dataModifyToExcel = (data) => {

    let dataReport = []
    let runNum = 6;
    if (data && data !== undefined && data.length > 0 ) {
        let temp = [];
        data.forEach((item,index) => {
           
            runNum = 6;
            let _item = {}
            for(let key in item){
                        
                switch(key) {
                    case 'seqPk' : { _item['col1'] = item[key]; break;}
                    case 'itemDesc' :{ _item['col2'] = item[key]; break;}
                    case 'itemUnitDesc' : { _item['col3'] = item[key]; break;}
                    case 'itemUnitPrice' : { _item['col4'] = item[key]; break;}
                    case 'contractUnit' : { _item['col5'] = item[key]; break;}
                    case 'contractAmount' : { _item['col6'] = item[key]; break;}
                    default : {
                        if(key !== "accrueUnit" && key  !== "updateKey" ){
                            // memoUnit_all: "จำนวน"
                            // routeAmount_1: "รวม"
                            let indexFind = (key.search("memoUnit_")>-1 || key.search("routeAmount_")>-1)?true:false;
                            if(indexFind){
                                runNum++;
                                _item[`col${runNum}`] = item[key]
                            }
                        }
                        break;
                    }

                }
            }
            _item = {
                ..._item,
                runNum
            }
            

            temp.push(_item)
        });

        dataReport = [...temp]
    } 

    return dataReport;
};